import { ApiResponse } from './../../models/response-api';
import { environment } from './../../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, tap } from 'rxjs';
import { CrudService } from '../crud-service/crud.service';
import Pusher from 'pusher-js';

@Injectable({
  providedIn: 'root',
})
export class ContactService extends CrudService<ApiResponse<any>, number> {
  messages$ = new Subject<any>();
  private pusher: any;
  private channel: any;
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);

    this.pusher = new Pusher('eb5150b9b1988b68581b', {
      cluster: 'mt1',
      disableStats: true,
    });
    this.channel = this.pusher.subscribe('chat');
    this.channel = this.pusher.subscribe('chat');

    this.channel.bind('App\\Events\\ChatEvent', (data: any) => {
      this.messages$.next(data);
    });
  }
  headerClass: string = '';

  setHeaderClass(className: string): void {
    this.headerClass = className;
  }
  getHeaderClass() {
    return this.headerClass;
  }
  readMessage(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Chat/markMessageAsRead`,
      data
    );
  }
  getContactNamesByCandidat(company_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/Mailing/getAllMailsToContactEsn?company_id=${company_id}`
    );
  }
 
  /*contac tWegestU */
  contactWegestU(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/ContactWegestu/create',
      body
    );
  }
  getNamesForContactWegestu() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/MailingAdmin/getNamesForContactWegestu`
    );
  }
  contactentreprise(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/ContactESN/create',
      body
    );
  }

  /*contact responsable */
  contactResponsable(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/ContactCompanyManager/ContactCompanyManager',
      body
    );
  }
  /*contact ESN */
  contactEsn(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/ContactESN/create',
      body
    );
  }
  ////////////////messagerie/////////////////////////////////////////////////////////////////
  private messageSentSubject: BehaviorSubject<void | null> =
    new BehaviorSubject<void | null>(null);

  getMessageSentObservable() {
    return this.messageSentSubject.asObservable();
  }

  sendMessage(id: any, message: string, emitterRole : string | null, receiverRole: string | null) {
    return this._http
      .post<any>(`${this._base}/api/Chat/sendMessage?id=${id}`, 
        { message, emitter_role :  emitterRole, receiver_role : receiverRole})
      .pipe(tap(() => this.messageSentSubject.next(null)));
  }

  getMessagesEmitter(id: any, roleConnected: any, roleReceiver : any) {
    return this._http.get<any>(
      `${this._base}/api/Chat/getMessagesBetweenUsers?id=${id}&role_connected=${roleConnected}&role_receiver=${roleReceiver}`
    );
  }

  getListUsers() {
    return this._http.get<any>(`${this._base}/api/Chat/listUsers`);
  }

  searchListUser(data: any, perPage : number, page : number) {
    return this._http.post<any>(
      `${this._base}/api/Chat/searchUserForESN?per_page=${perPage}&page=${page + 1}`,
      data
    );
  }

  searchListUserclient(data: any) {
    return this._http.post<any>(
      this._base + `/api/Chat/searchUserForCandidat`,
      data
    );
  }
  searchListMessage(data: any, perPage : number, page : number) {
    return this._http.post<any>(
      this._base + `/api/Chat/searchInMessagesByUser?per_page=${perPage}&page=${page + 1}`,
      data
    );
  }

  deleteConversation(receiverId: number) {
    return this._http.delete(this._base + `/api/Chat/deleteDiscussion`, {
      params: {
        receiver_id: receiverId.toString(),
      },
    });
  }
  getListMessage() {
    return this._http.get<any>(`${this._base}/api/Chat/getMessagesByUser`);
  }

  getUnreadMessage(roleConnected: any) {
    return this._http.get<any>(`${this._base}/api/Chat/fetchMessagesReceiver?role_connected=${roleConnected}`);
  }

}
